import { FunctionComponent } from "react";
import { Place } from "@dto/Place";
import { Tour } from "@dto/Tour";
import { Event } from "@dto/Event";
import { Plannable } from "@dto/Plannable";
import { Goal } from "@dto/Goal";
import { FeedPost } from "@dto/FeedPost";
import { TripBuilderEntity } from "@dto/TripBuilder";
import { Text } from "@ui-kit/Text/Text";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

interface ListingValueProps {
  entity?:
    | Place
    | Tour
    | Event
    | Plannable
    | Goal
    | Tour
    | FeedPost
    | TripBuilderEntity;
}

const ListingValue: FunctionComponent<ListingValueProps> = ({ entity }) => {
  const formattedListingValue = (entity as Place)?.formattedListingValue;

  if (!formattedListingValue) {
    return <></>;
  }

  return (
    <Text variant="fontBodyMedium" color={colors.neutral600}>
      {formattedListingValue}
    </Text>
  );
};

export { ListingValue };
